import React from 'react'
import clsx from 'clsx'
import { withStyles } from '@material-ui/core/styles'
import { Icon } from '@iconify/react'
import { Link, useHistory, useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { collectionShowcaseAction } from 'src/reducers/collection/action'
import { Account } from '../top-bar/components'
import { NAV_ITEMS, isNavItemActive } from './nav-items'
import styles from './styles'

const HELP_CENTER_URL = 'https://intercom.help/mini-course-generator/en/'

// Open the account menu to the right of the avatar instead of below it.
const ACCOUNT_POPOVER_PROPS = {
  anchorOrigin: { vertical: 'bottom', horizontal: 'right' },
  transformOrigin: { vertical: 'bottom', horizontal: 'left' },
  hideArrow: true,
  PaperProps: { style: { marginTop: 0, marginLeft: 12 } },
}

const SideNav = ({ classes }) => {
  const { pathname } = useLocation()
  const history = useHistory()
  const dispatch = useDispatch()
  const isShowcaseOpen = useSelector(
    state => state.collection.collection?.type === 1,
  )

  const handleHelpClick = () => {
    if (window.Intercom) {
      window.Intercom('showSpace', 'help')
    } else {
      window.open(HELP_CENTER_URL, '_blank', 'noopener,noreferrer')
    }
  }

  // Creates the showcase on first use, then opens its landing page.
  const openShowcase = event => {
    event.preventDefault()
    dispatch(
      collectionShowcaseAction({}, response => {
        history.push(`/collection/${response.id}/landing-page`)
      }),
    )
  }

  const renderAccountTrigger = ({ ref, onClick, initials, isOpen }) => (
    <button
      ref={ref}
      type="button"
      title="Account"
      className={clsx(classes.avatar, isOpen && classes.avatarOpen)}
      onClick={onClick}
    >
      {initials}
    </button>
  )

  return (
    <nav className={classes.root} aria-label="Main navigation">
      <Link to="/" className={classes.logo} aria-label="Home">
        <img
          src="/assets/mcg-logo-mark.svg"
          alt="Mini Course Generator"
          className={classes.logoImage}
        />
      </Link>

      {NAV_ITEMS.map(item => {
        const isActive = isNavItemActive(item, pathname, isShowcaseOpen)

        return (
          <Link
            key={item.id}
            to={item.to || '#'}
            title={item.tooltip || item.label}
            className={clsx(classes.item, isActive && classes.itemActive)}
            aria-current={isActive ? 'page' : undefined}
            onClick={event => {
              if (item.opensShowcase) openShowcase(event)
            }}
          >
            {item.isNew && <span className={classes.newBadge}>NEW</span>}
            <Icon icon={item.icon} className={classes.icon} />
            <span className={classes.label}>{item.label}</span>
          </Link>
        )
      })}

      <div className={classes.footer}>
        <button
          type="button"
          title="Help center"
          className={classes.item}
          onClick={handleHelpClick}
        >
          <Icon icon="tabler:help-circle" className={classes.icon} />
          <span className={classes.label}>Help</span>
        </button>
        <Account
          popoverProps={ACCOUNT_POPOVER_PROPS}
          renderTrigger={renderAccountTrigger}
        />
      </div>
    </nav>
  )
}

export default withStyles(styles)(SideNav)
